import { Component } from '@angular/core';

@Component({
  selector: 'app-development-procurement-card',
  templateUrl: './development-procurement-card.component.html',
  styleUrls: ['./development-procurement-card.component.scss']
})
export class DevelopmentProcurementCardComponent {

}
